import { Toast } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

import { useGetNotifiedModal } from './GetNotifiedModalContext'

export const GetNotifiedConfirmationToast = () => {
  const { t } = useTranslation('@mc/next')
  const { showToast } = useGetNotifiedModal()

  return (
    showToast && (
      <Toast show kind='success'>
        <div className='mc-w-100 mc-text--center d-none d-md-block'>
          {t('episode.comingSoon.modal.confirmationToast')}
        </div>
        <div className='mc-w-100 mc-text--center d-md-none'>
          {t('episode.comingSoon.modal.confirmationToastMobile')}
        </div>
      </Toast>
    )
  )
}
